import {
	SECTION_LABELS,
	type Notification,
	type NotificationKind,
	type NotificationTarget,
} from "@ravnar/api-contract";

import type { NotificationTag } from "../components/ui/notification-row";

/** How many unattended notifications the bell's menu lists before "See all" takes over. */
export const RECENT_NOTIFICATION_COUNT = 4;

/** What the page a notification is about is called where a notification links to it: the names the rail gives them. */
export const NOTIFICATION_TARGET_LABELS: Readonly<Record<NotificationTarget, string>> = {
	"/work": "Work",
	"/directory": "Directory",
	"/intake": "Intake",
	"/finance": SECTION_LABELS.finance,
	"/legal": SECTION_LABELS.legal,
	"/people": SECTION_LABELS.people,
	"/equity": SECTION_LABELS.equity,
};

/**
 * The kinds the Notifications page filters on, beside All: the notifications with work items attached. A notice has no
 * filter of its own.
 */
export const NOTIFICATION_FILTERS = ["work"] as const satisfies readonly NotificationKind[];
export type NotificationFilter = (typeof NOTIFICATION_FILTERS)[number];

/** What each filter's pill says. */
export const NOTIFICATION_FILTER_LABELS: Readonly<Record<NotificationFilter, string>> = {
	work: "Work items",
};

/** "1 work item", "2 work items". */
export function workItemCount(count: number): string {
	return count === 1 ? "1 work item" : `${String(count)} work items`;
}

/**
 * The chip a notification's row carries before its time: for one about work, how many work items it names, in the
 * warning tone the Work page gives work still to do; for a notice, none.
 */
export function notificationTag({ kind, workItemIds = [] }: Notification): NotificationTag | undefined {
	switch (kind) {
		case "work": {
			return { label: workItemCount(workItemIds.length), tone: "warn" };
		}
		case "notice": {
			return undefined;
		}
	}
}
